<script setup lang="ts">
import GroupTable from "@/components/group/GroupTable.vue"
import { useGroupStore } from "@/stores/groups.ts";

const groupStore = useGroupStore();

</script>

<template>
  <div class="page">
    <div class="panel" v-for="group in groupStore.groups">
      <GroupTable :group="group" />
    </div>
    <div class="hint">
      G - Gewonnen, U - Unentschieden, V - Verloren<br>
      Angaben ohne Gewähr. Fehler vorbehalten.
    </div>
  </div>
</template>

<style scoped>
.hint {
  text-align: center;
  font-size: 0.8rem;
  color: var(--text-color-layer-1);
}
</style>
